import { AmenitiesInput } from "../pages/page-components/Amenities/TabAddAmenities";
import httpUtil from "../utils/http.util";

class AmenitiesService {
  async createAmenity(data: AmenitiesInput, multipart: boolean) {
    return await httpUtil.post("/amenity/create", data, multipart);
  }

  async getAllAmenities() {
    return await httpUtil.get("amenity/getAll");
  }

  async deleteAmenity(id: string) {
    return await httpUtil.delete("amenity/delete", id);
  }
}

export default new AmenitiesService();
